import * as getters from "./favourites.getters";
import * as actions from "./favourites.actions";
import * as mutations from "./favourites.mutations";

const state = {
    favourites: [],
    favouriteHome: false,
    favouriteWork: false,
    favouritesLists: [],
    savedFavouriteTypes: [],
    savedRoutes: false,
    savedRoutesListOpen: false,
    savedRouteClicked: false, // will be set when saved route is clicked
    savedRouteInfo: {}, // will be set when saved route is clicked
    activeRouteSaved: false, // will be set when the currently active route is saved to show the filled star
    favouritePickerOpen: false,
    favouritePickerFieldIndex: 0,
    openFavouriteOverlayAfterLogin: {},
    routeTrafficAlerts: false,
    searchInputType: false,
}

export default {
    namespaced: false,
    state,
    getters,
    actions,
    mutations
}